/**
 * MDMC console entitlement — client-side gate until BTCPay tier webhooks land.
 * Paid tiers set sessionStorage after checkout redirect (?mdmc_tier=Operator&paid=1).
 */
const STORAGE_KEY = 'mdmc_entitlement_tier'

const TIER_RANK = {
  Observer: 0,
  Operator: 1,
  Researcher: 2,
  Institutional: 3,
}

export function captureEntitlementFromUrl() {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const tier = params.get('mdmc_tier')
  const paid = params.get('paid')
  if (tier && paid === '1' && tier in TIER_RANK) {
    sessionStorage.setItem(STORAGE_KEY, tier)
  }
}

export function getEntitlementTier() {
  if (typeof window === 'undefined') return 'Observer'
  return sessionStorage.getItem(STORAGE_KEY) || 'Observer'
}

export function tierMeetsMinimum(required) {
  const current = getEntitlementTier()
  return (TIER_RANK[current] ?? 0) >= (TIER_RANK[required] ?? 0)
}

export function checkoutUrlForTier(tier) {
  const slug = String(tier).toLowerCase()
  return `https://makersconsulting.com/#contact?service=mdmc-${slug}-tier`
}
